export const SEARCH_BUSINESS = 'SEARCH_BUSINESS';
export const LOAD_BUSINESS = 'LOAD_BUSINESS';
export const ADD_EMPLOYEE = 'ADD_EMPLOYEE';
export const REMOVE_EMPLOYEE = 'REMOVE_EMPLOYEE';
export const EDIT_EMPLOYEE = 'EDIT_EMPLOYEE';
